import React from "react";

import usePageContent from "../../hooks/usePageContent";
import EditableSection from "../../components/CMS/EditableSection";
import("../../app/styles/founders.css");

import FounderIntroSection from "./FounderIntroSection";
import FounderJourneySection from "./FounderJourneySection";
import FounderTeamSection from "./FounderTeamSection";
import FounderNextChapterSection from "./FounderNextChapterSection";

import GenericSectionEditor from "../../components/CMS/editors/GenericSectionEditor";


const FounderPage = ({ user }) => {

    const {
        get,
        loading,
        error,
        refresh
    } = usePageContent("founders");


    const editable = !!user;


    if (loading) {
        return (
            <div className="container">
                <p>Loading...</p>
            </div>
        );
    }


    if (error) {
        return (
            <div className="container">
                <p>
                    Failed to load founders page.
                </p>
            </div>
        );
    }


    return (
        <>
            <EditableSection
                uniqueId="founders-intro"
                title="A Journey from Engineering to"
                data={get("intro")}
                Display={FounderIntroSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-journey"
                title="Founder Journey"
                data={get("journey")}
                Display={FounderJourneySection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-team"
                title="Founding Family"
                data={get("team")}
                Display={FounderTeamSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-current"
                title="Founders & Journey"
                data={get("next")}
                Display={FounderNextChapterSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
        </>
    );
};


export default FounderPage;